module.exports = __webpack_public_path__ + "img/btn下@2x.3090a4d2.png";